import React, { useEffect, useState } from 'react'
import './Style/newsStyle.scss'
import { Avatar, Button, Col, Dropdown, Modal, Tag } from 'antd'
import { getNameSignature } from 'helper/utility'
import Actionicon from 'assets/Images/Action.svg'
import Map from 'helper/Map/Map'
import NewsImageContainer from './NewsImageContainer'
import LikeCount from './LikeCount'
import moment from 'moment'
import ViewAddress from 'helper/Map/ViewAddress'
import { removeReactionFromNews, deleteNews, editNews, publishNews } from 'api/News'
import { ShareAltOutlined, DeleteOutlined } from '@ant-design/icons'
import ArrowCounterClockwise from 'assets/Images/ArrowCounter.svg'
import UnpublishModal from './UnpublishModal'
import { stripHtmlTags } from 'helper/utility'
import {
  ThumbsUp,
  PushPinSimple,
  // PaperPlaneTilt,
} from '@phosphor-icons/react'
import { useMutation } from '@tanstack/react-query'
import { NewsStatus } from 'types/News'
import { getPostStatus } from 'helper/blogStatusColors'

let activeAudioElement: HTMLAudioElement | null = null
let activeVideoElement: HTMLVideoElement | null = null

const BasicNewsLayout = ({ newsData, parms, onRefresh, onEditNews }: any) => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [reason, setReason] = useState('') // State to store reason dropdown value
  const [comments, setComments] = useState('')
  const { backgroundColor, color } = getPostStatus(newsData?.status)
  const showModal = () => {
    setIsModalVisible(true)
  }

  const showEditModal = () => {
    if (onEditNews) {
      onEditNews(newsData)
    }
  }


  const handleClose = () => {
    setIsModalVisible(false)
    setComments('')
    setReason('')
  }

  const handleUnpublish = () => {
    // Here you can add the API call or any logic to unpublish the news.
    setIsModalVisible(false)
  }


  const handlePublish = async () => {
    Modal.confirm({
      title: 'Publish News',
      content: 'Are you sure you want to publish this news?',
      okText: 'Publish',
      okType: 'primary',
      cancelText: 'Cancel',
      onOk() {
        return publishNewsAction()
      },
    })
  }

  const publishNewsAction = async () => {
    try {
      await publishNews(newsData?._id)
      if (onRefresh) {
        onRefresh()
      }
    } catch (error) {
      console.error('Error publishing news:', error)
    }
  }

  const handleDropdownItemClick = (e: any) => {
    const { key } = e
    switch (key) {
      case 'pin':
        console.log('Pin post clicked')
        break
      case 'edit':
        showEditModal()
        break
      case 'delete':
        Modal.confirm({
          title: 'Delete News',
          content: 'Are you sure you want to delete this News?',
          okText: 'Delete',
          okType: 'danger',
          cancelText: 'Cancel',
          onOk() {
            deleteNews(newsData?._id)
              .then(() => {
                if (onRefresh) {
                  onRefresh()
                }
              })
              .catch((error) => {
                console.error('Error deleting news:', error)
              })
          },
        })
        break
      case 'publish':
        Modal.confirm({
          title: 'publish News',
          content: 'Are you sure you want to publish this News?',
          okText: 'Publish',
          okType: 'primary',
          cancelText: 'Cancel',
          onOk() {
            publishNews(newsData?._id)
              .then(() => {
                if (onRefresh) {
                  onRefresh()
                }
              })
              .catch((error) => {
                console.error('Error undoing news:', error)
              })
          },
        })
        break
      default:
        break
    }
  }
  const items = [
    {
      key: 'pin',
      label: <p>Pin post</p>,
    },
    {
      key: 'edit',
      label: <p>Edit post</p>,
    },
    {
      key: newsData?.status === NewsStatus.Archived ? 'publish' : 'delete',
      label: <p>{newsData?.status === NewsStatus.Archived ? 'Publish' : 'Delete post'}</p>,
    },
  ]

  const currentAudioRef = React.useRef<HTMLAudioElement | null>(null)
  const currentVideoRef = React.useRef<HTMLVideoElement | null>(null)

  const handleAudioPlay = (audioEl: HTMLAudioElement) => {
    if (activeAudioElement && activeAudioElement !== audioEl) {
      activeAudioElement.pause()
      activeAudioElement.currentTime = 0
    }

    if (activeVideoElement) {
      activeVideoElement.pause()
      activeVideoElement.currentTime = 0
      activeVideoElement = null
      currentVideoRef.current = null
    }

    activeAudioElement = audioEl
    currentAudioRef.current = audioEl
  }

  const handleAudioEnd = (audioEl: HTMLAudioElement) => {
    if (currentAudioRef.current === audioEl) {
      currentAudioRef.current = null
    }
    if (activeAudioElement === audioEl) {
      activeAudioElement = null
    }
  }

  const handleVideoPlay = (videoEl: HTMLVideoElement) => {
    if (activeVideoElement && activeVideoElement !== videoEl) {
      activeVideoElement.pause()
      activeVideoElement.currentTime = 0
    }

    if (activeAudioElement) {
      activeAudioElement.pause()
      activeAudioElement.currentTime = 0
      activeAudioElement = null
      currentAudioRef.current = null
    }

    activeVideoElement = videoEl
    currentVideoRef.current = videoEl
  }

  const handleVideoEnd = (videoEl: HTMLVideoElement) => {
    if (currentVideoRef.current === videoEl) {
      currentVideoRef.current = null
    }
    if (activeVideoElement === videoEl) {
      activeVideoElement = null
    }
  }

  useEffect(() => {
    return () => {
      if (currentAudioRef.current) {
        currentAudioRef.current.pause()
      }
      if (currentVideoRef.current) {
        currentVideoRef.current.pause()
      }
      activeAudioElement = null
      activeVideoElement = null
      currentAudioRef.current = null
      currentVideoRef.current = null
    }
  }, [])

  return (
    <>
      <Col key={newsData?._id} className="  br-12 basic_newsContainer">
        <div>
          <div className="px-20 py-20 d-flex justify-between align-items-center">
            <div
              className="d-flex gap-20 align-items-center cursot-pointer"
            //   onClick={() =>
            //     router.push(
            //       `/organizationdetails/${newsData?.organization?.id}`
            //     )
            //   }
            >
              <Avatar size={50} src={newsData?.organization?.photo?.post}>
                {getNameSignature(newsData?.organization?.name)}
              </Avatar>
              <div>
                <div className="d-flex gap-10 align-items-center  ">
                  <h3 className="font14 b1">{newsData?.organization?.name}</h3>
                  <p className="gray_text">
                    {moment().diff(newsData?.createdAt, 'days') === 0
                      ? 'Today'
                      : `${moment().diff(
                        newsData?.createdAt,
                        'days',
                      )} days ago`}
                  </p>
                  <div>
                    <Tag
                      style={{
                        border: "none",
                        backgroundColor,
                        color,
                        borderRadius: '15px',
                        padding: '4px 10px',
                        fontWeight: 'bold',
                      }}
                    >
                      {newsData?.status?.toUpperCase() || 'UNKNOWN'}
                    </Tag>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <Dropdown
                menu={{
                  items: items,
                  onClick: e => handleDropdownItemClick(e),
                }}
                placement="bottom"
              >
                <img alt="img" src={Actionicon} style={{ cursor: 'pointer' }} />
              </Dropdown>
              {/* {newsData?.isPinned && <PushPinSimple size={24} color="#000" />} */}
            </div>
            {/* <div>
              {authenticated && (
                <PinNews
                  handlePin={handlePin}
                  newsData={newsData}
                  pinned={pinned}
                />
              )}
            </div> */}
          </div>
          <div className="px-20 mt-10 br-12 news-feed">
            {newsData?.title && (
              <div className="mt-16">
                <h3 className="font14 b1">{newsData?.title}</h3>
              </div>
            )}
            <p className="mt-10">{stripHtmlTags(newsData?.text)}</p>

            {newsData?.images.length ? (
              <NewsImageContainer images={newsData?.images} />
            ) : null}

            {newsData?.videos?.map(video => {
              return (
                <div key={video?._id} className="mt-16 br-12">
                  <video
                    width="555"
                    height="300"
                    controls
                    onPlay={e => handleVideoPlay(e.currentTarget)}
                    onEnded={e => handleVideoPlay(e.currentTarget)}
                  >
                    <source src={video?.link} type="video/mp4" />
                  </video>
                </div>
              )
            })}

            {newsData?.audios?.map(audio => {
              return (
                <div key={audio?._id} className="mt-16">
                  <audio
                    controls
                    onPlay={e => handleAudioPlay(e.currentTarget)}
                    onEnded={e => handleAudioEnd(e.currentTarget)}
                  >
                    <source src={audio?.link} type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                </div>
              )
            })}

            {newsData?.address ? (
              <div className="mt-10 br-12">
                <div className="mt-10 mb-16 gap-16 d-flex align-items-center justify-between">
                  <h3 className="font14 b-2">{`${newsData?.address?.apartment} ${newsData?.address?.street} ${newsData?.address?.city}, ${newsData?.address?.country}`}</h3>
                  <a
                    href={`https://www.google.com/maps/dir/${newsData.address.city}/${newsData.address.street}, ${newsData.address.city}, ${newsData.address.country}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button className="stepper-button">View location</Button>
                  </a>
                </div>

                <ViewAddress onlyView={true} mapData={newsData?.address} />
              </div>
            ) : null}
          </div>
          <div className="px-20 like_count d-flex align-items-center">
            <LikeCount reactions={newsData?.reactions} />
            <p className={` gray_text font14 b2`}>
              {newsData?.reactions?.length}
            </p>
          </div>
          {newsData?.status !== NewsStatus.Archived && (
            <div className="action-buttons d-flex justify-center align-items-center mt-20">
              {newsData?.status === NewsStatus.UnPublished ? (
                <Button
                  className="unpublish-button"
                  type="text"
                  onClick={handlePublish}
                >
                  <img
                    src={ArrowCounterClockwise}
                    alt="ArrowCounterClockwise"
                    style={{ marginRight: '10px' }}
                  />
                  Publish
                </Button>
              ) : (
                <Button
                  className="unpublish-button"
                  type="text"
                  onClick={showModal}
                >
                  <img
                    src={ArrowCounterClockwise}
                    alt="ArrowCounterClockwise"
                    style={{ marginRight: '10px' }}
                  />{' '}
                  Unpublish
                </Button>
              )}
              {/* 
            <Button className="share-button" type="text">
              Share
            </Button> */}
            </div>
          )}
        </div>
      </Col>
      <UnpublishModal
        parms={parms}
        newsid={newsData?._id}
        visible={isModalVisible}
        onClose={handleClose}
        onUnpublish={handleUnpublish}
        reason={reason}
        comments={comments}
        setReason={setReason}
        setComments={setComments}
      />
    </>
  )
}
export default BasicNewsLayout
